import React from 'react'
import { Novelty, RealEstateDataPageComponentData, TagMediacore } from 'types'
import NoveltyCard_6 from '../6'

type Props = {
  hidenTags: boolean
  skeleton: boolean
  hidenAuthor?: boolean
  isHome: boolean
  novelty: Novelty
  tags: TagMediacore[]
  dispatch: any
  isSummaryCard: boolean
  placeholder?: string
  upperCaseLink?: boolean
  dateFormat?: 'long' | 'short'
  keyIndex?: number
}

const NoveltyCard_7 = (props: Props & RealEstateDataPageComponentData) => {
  const global_data = props?.global_data

  const {
    backgroundColor,
    backgroundHexa,
    titleElement,
    spanText,
    placeholder,
    dateFormat,
    paragraphColor,
    hidenAuthor
  } = global_data.content.cardsNovelties.data

  return (
    <NoveltyCard_6
      {...props}
      backgroundColor={backgroundColor}
      backgroundHexa={backgroundHexa}
      titleElement={titleElement}
      spanText={spanText}
      placeholder={placeholder}
      dateFormat={dateFormat}
      paragraphColor={paragraphColor}
      opacityGradient={true}
      hidenTags={true}
      hidenAuthor={hidenAuthor}
    />
  )
}

export default NoveltyCard_7
